import { SheepState } from './Sheep';

export const initialGameInput = {
    gameState: 'CREATED',
    roomId: 'PPRL',
    playersState: [
        {
            id: 'PZ-x-YLS4lJqsXdI1dDOs',
            name: 'Natasha',
            positionX: 100,
            positionY: 100,
            finished: false,
            isActive: true,
            characterNumber: 0,
        },
        {
            id: 'PZ-x-YLS4lJqsXdI1dDOs',
            name: 'Magdalena',
            positionX: 2400,
            positionY: 1118,
            finished: false,
            isActive: true,
            characterNumber: 1,
        },
        {
            id: 'PZ-x-YLS4lJqsXdI1dDOs',
            name: 'Ash',
            positionX: 100,
            positionY: 1118,
            finished: false,
            isActive: true,
            characterNumber: 2,
        },
        {
            id: 'PZ-x-YLS4lJqsXdI1dDOs',
            name: 'Robin',
            positionX: 2400,
            positionY: 100,
            finished: false,
            isActive: true,
            characterNumber: 3,
        },
    ],
    sheep: [
        { id: '0', posX: 544, posY: 1188, state: SheepState.ALIVE },
        { id: '1', posX: 2157, posY: 668, state: SheepState.ALIVE },
        { id: '2', posX: 1113, posY: 446, state: SheepState.ALIVE },
        { id: '3', posX: 1767, posY: 910, state: SheepState.ALIVE },
        { id: '4', posX: 284, posY: 567, state: SheepState.ALIVE },
        { id: '5', posX: 889, posY: 497, state: SheepState.ALIVE },
        { id: '6', posX: 607, posY: 748, state: SheepState.ALIVE },
        { id: '7', posX: 2093, posY: 1087, state: SheepState.ALIVE },
        { id: '8', posX: 2031, posY: 497, state: SheepState.ALIVE },
        { id: '9', posX: 730, posY: 1071, state: SheepState.ALIVE },
        { id: '10', posX: 784, posY: 809, state: SheepState.ALIVE },
        { id: '11', posX: 1483, posY: 26, state: SheepState.ALIVE },
        { id: '12', posX: 56, posY: 512, state: SheepState.ALIVE },
        { id: '13', posX: 1898, posY: 796, state: SheepState.ALIVE },
        { id: '14', posX: 2070, posY: 80, state: SheepState.ALIVE },
        { id: '15', posX: 321, posY: 29, state: SheepState.ALIVE },
        { id: '16', posX: 580, posY: 131, state: SheepState.ALIVE },
        { id: '17', posX: 481, posY: 906, state: SheepState.ALIVE },
        { id: '18', posX: 808, posY: 257, state: SheepState.ALIVE },
        { id: '19', posX: 1804, posY: 965, state: SheepState.ALIVE },
        { id: '20', posX: 1874, posY: 269, state: SheepState.ALIVE },
        { id: '21', posX: 197, posY: 932, state: SheepState.ALIVE },
        { id: '22', posX: 808, posY: 908, state: SheepState.ALIVE },
        { id: '23', posX: 1187, posY: 291, state: SheepState.ALIVE },
        { id: '24', posX: 2457, posY: 882, state: SheepState.ALIVE },
        { id: '25', posX: 835, posY: 1056, state: SheepState.ALIVE },
        { id: '26', posX: 1265, posY: 391, state: SheepState.ALIVE },
        { id: '27', posX: 2355, posY: 763, state: SheepState.ALIVE },
        { id: '28', posX: 705, posY: 232, state: SheepState.ALIVE },
        { id: '29', posX: 291, posY: 377, state: SheepState.ALIVE },
        { id: '30', posX: 760, posY: 172, state: SheepState.ALIVE },
        { id: '31', posX: 1634, posY: 536, state: SheepState.ALIVE },
        { id: '32', posX: 1391, posY: 795, state: SheepState.ALIVE },
        { id: '33', posX: 1933, posY: 211, state: SheepState.ALIVE },
        { id: '34', posX: 527, posY: 654, state: SheepState.ALIVE },
        { id: '35', posX: 826, posY: 726, state: SheepState.ALIVE },
        { id: '36', posX: 2227, posY: 320, state: SheepState.ALIVE },
        { id: '37', posX: 1791, posY: 127, state: SheepState.ALIVE },
        { id: '38', posX: 2019, posY: 305, state: SheepState.ALIVE },
        { id: '39', posX: 1127, posY: 965, state: SheepState.ALIVE },
        { id: '40', posX: 1768, posY: 652, state: SheepState.ALIVE },
        { id: '41', posX: 1643, posY: 1037, state: SheepState.ALIVE },
        { id: '42', posX: 2039, posY: 277, state: SheepState.ALIVE },
        { id: '43', posX: 583, posY: 225, state: SheepState.ALIVE },
        { id: '44', posX: 921, posY: 397, state: SheepState.ALIVE },
        { id: '45', posX: 1649, posY: 759, state: SheepState.ALIVE },
        { id: '46', posX: 1214, posY: 537, state: SheepState.ALIVE },
        { id: '47', posX: 2460, posY: 467, state: SheepState.ALIVE },
        { id: '48', posX: 1881, posY: 43, state: SheepState.ALIVE },
        { id: '49', posX: 2239, posY: 1078, state: SheepState.ALIVE },
        { id: '50', posX: 667, posY: 621, state: SheepState.ALIVE },
        { id: '51', posX: 1310, posY: 424, state: SheepState.ALIVE },
        { id: '52', posX: 802, posY: 1092, state: SheepState.ALIVE },
        { id: '53', posX: 1979, posY: 992, state: SheepState.ALIVE },
        { id: '54', posX: 1827, posY: 457, state: SheepState.ALIVE },
        { id: '55', posX: 2241, posY: 909, state: SheepState.ALIVE },
        { id: '56', posX: 233, posY: 510, state: SheepState.ALIVE },
        { id: '57', posX: 1560, posY: 453, state: SheepState.ALIVE },
        { id: '58', posX: 392, posY: 1184, state: SheepState.ALIVE },
        { id: '59', posX: 861, posY: 509, state: SheepState.ALIVE },
        { id: '60', posX: 2441, posY: 1194, state: SheepState.ALIVE },
        { id: '61', posX: 1941, posY: 324, state: SheepState.ALIVE },
        { id: '62', posX: 2471, posY: 33, state: SheepState.ALIVE },
        { id: '63', posX: 1181, posY: 809, state: SheepState.ALIVE },
        { id: '64', posX: 1569, posY: 143, state: SheepState.ALIVE },
        { id: '65', posX: 538, posY: 442, state: SheepState.ALIVE },
        { id: '66', posX: 742, posY: 853, state: SheepState.ALIVE },
        { id: '67', posX: 2211, posY: 367, state: SheepState.ALIVE },
    ],
    lengthX: 2500,
    lengthY: 1218,
    round: 1,
    phase: 'counting',
    timeLeft: 50000,
    aliveSheepCounts: [null, null, null],
    brightness: 100,
};
